<template>
	<v-container class="noMargin">		
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1">					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>LINKED VENDORS</h2>	          
				</div>                
				<v-btn v-if="vendorsIni != 0" @click.prevent="fncVendorSaveData" class="elevation-5" color="info"><i class="material-icons">add</i>Save Vendors</v-btn>
			</v-flex>
		</v-layout>		
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 	

	export default {
		name: 'RoleHeader',
		data () {
			return {				
			}		
		},
		methods: {
          fncVendorSaveData() {            
		    this.$store.dispatch('fncVendorSaveData')
          }          
		},
		computed: {
			...mapGetters([			
            'objAuthorize',
            'vendorsIni'
			])
		}
	}
</script>

<style scoped>
  @import '../../shared/assets/css/shared.css'
</style>